import type { LoomSpace } from '../../types';

export const isLoomSpace = (entity: any): entity is LoomSpace => entity.__typename === 'LoomSpace';

export const getLoomSpaceLink = (space: LoomSpace): string | null => space?.url ?? null;
